function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  "data-svg-class": "ServiceTypeButton-image-fill"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "ServiceTypeButton-image-stroke",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.445 12.5A4.952 4.952 0 00.5 17.46v116.08c0 2.74 2.214 4.96 4.945 4.96h80.11a4.952 4.952 0 004.945-4.96V17.46c0-2.74-2.214-4.96-4.945-4.96L75.5 12.489V11A1.5 1.5 0 0074 9.5H54.5V9a8.5 8.5 0 10-17 0v.5H17a1.5 1.5 0 00-1.5 1.5v1.484L5.445 12.5z"
})), /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "ServiceTypeButton-image-stroke",
  stroke: "#FFF",
  cx: 46,
  cy: 7,
  r: 1.75
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "ServiceTypeButton-image-stroke",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17 42.151L22.134 47 30 37M17 64.151L22.134 69 30 59M17 86.151L22.134 91 30 81m-13 27.151L22.134 113 30 103m4.297-59.5h38.338m-38.338 22h38.338m-38.338 22h38.338m-38.338 22h38.338"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "ServiceTypeButton-image-stroke",
  stroke: "#FFF",
  d: "M15.5 18a1.5 1.5 0 001.5 1.5h57a1.5 1.5 0 001.5-1.5l-.076-.5H84.5v115h-78v-115h9.529"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "ServiceTypeButton-image-stroke",
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M15.5 12.5v5m60-5v5"
}));

function SvgSelectServiceTypeMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 139,
    viewBox: "0 0 91 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectServiceTypeMaintenance);
export default __webpack_public_path__ + "static/media/SelectServiceTypeMaintenance.28b49c01.svg";
export { ForwardRef as ReactComponent };